<template>
	<NuxtLoadingIndicator color="green"/>

	<div>
		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>

		<UNotifications />
	</div>
</template>

<script setup lang="ts">
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - SafeCrypto ADMIN` : 'SafeCrypto ADMIN';
  }
})

onMounted(() => {
  if ('serviceWorker' in navigator) {
	navigator.serviceWorker
	  .register('/sw.js')
	  .then((registration) => {
		console.log('Сервис-воркер зарегистрирован:', registration);
	  })
	  .catch((error) => {
		console.error('Ошибка регистрации сервис-воркера:', error);
	  });
  }
});
</script>
